export default function normalize(str) {
  // EX. HERMÈS -> HERMES
  return str.normalize('NFD').replace(/\W/g, '');
}
